import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';

import { CookieService } from 'ngx-cookie';

import { AclDialogComponent } from 'app/modules/shared/components/acl-dialog/acl-dialog.component';
import { messages } from 'app/constants';
import { ACLService } from 'app/services/acl.service';
import { HelperService } from 'app/services/helper.service';

@Injectable()
export class AccessGuard implements CanActivateChild {
  private token: any;
  private isRouteForbiddenDialogOpen: boolean = false;

  constructor(private router: Router, private dialogService: DialogService, private helpService: HelperService, private cookieService: CookieService, private aclService: ACLService) {}
  /**
   * Activate routes based on roles
   * @param  {ActivatedRouteSnapshot} activatedRoute Activated routes snapshot
   * @param  {RouterStateSnapshot} route Router state representer
   * @returns {Boolean} Boolean True when role is allowed to access route
   */
  canActivateChild(activatedRoute: ActivatedRouteSnapshot) {
    // get token from cookie
    this.token = this.helpService.jwtDecode(this.cookieService.getObject('alpat'));

    // ActivatedRouteSnapshot id not exists
    if (!activatedRoute.data || !activatedRoute.data.id) {
      return true;
    }

    // if token not exists
    if (!this.token || !this.token.role) {
      // show error toaster and navigate to login
      this.helpService.showToaster('error', messages.unAuthorized);
      this.helpService.logout();
      return false;
    }

    // for (super , onboarder , sales , engg)
    if (['super', 'onboarder', 'engg', 'sales'].includes(this.token.role)) {
      return true;
    }

    // navigation hack (dirty code , need verification if still valid)
    if (activatedRoute.data.id === 'admin-qbo') {
      this.router.navigate(['/settings/integrations/quickbook/', activatedRoute.params.companyId]);
      return false;
    }

    // check access on routed page
    // return true;
    if (this.aclService.pageAccessPermission(activatedRoute.data, this.token.role, this.token.isWorkAsTechEnabled)) {
      return true;
    }

    // if page access is denied
    this.router.navigate([this.aclService.getEntry(this.token.role)]);

    // open forbidden dialog
    this.openForbiddenDialog();

    return false;
  }

  openForbiddenDialog() {
    // check if dialog is already open
    if (!this.isRouteForbiddenDialogOpen) {
      // set open true
      this.isRouteForbiddenDialogOpen = true;
      const dialogRef = this.dialogService.open(AclDialogComponent, {
        width: '500px',
        styleClass: 'small-heading-dialog',
        data: {
          title: `Feature not enabled`,
          subTitle: `It seems you don’t have access to this feature. You can request your admin to enable your access.`,
        },
        showHeader: false,
      });

      const onClose = dialogRef.onClose.subscribe(() => {
        // set open false on close
        this.isRouteForbiddenDialogOpen = false;
        onClose.unsubscribe();
      });
    }
  }
}
